<template>
  <div class="mgt-10px VueTables">
    <div class="table-responsive">
      <table class="VueTables__table table is-striped-reverse is-fullwidth">
        <tbody>
        <tr v-if="recapitulatif.totalHors">
          <td></td>
          <td>
            {{ $t('detail.commande.recapitulatifMontants.horsTotal',
            { groupeProduitDeductible: getTitleHors }) }}
          </td>
          <td class="right"><strong>{{ recapitulatif.totalHors }}</strong></td>
        </tr>
        <tr v-for="(recapTotalHors, index) in recapitulatif.total"
            :key="index">
          <td></td>
          <td>{{ recapTotalHors.libelle }}</td>
          <td class="right"> {{ recapTotalHors.total | decimalFormatters }} </td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t('detail.commande.recapitulatifMontants.totalHt') }}</td>
          <td class="right"><strong>{{ recapitulatif.montantHtFormated }}</strong></td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t('detail.commande.recapitulatifMontants.tva') }}</td>
          <td class="right">{{ recapitulatif.montantTvaFormated }}</td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t('detail.commande.recapitulatifMontants.totalTtc') }}</td>
          <td class="right"><strong>{{ recapitulatif.montantTtcFormated }}</strong></td>
        </tr>
        <tr v-if="recapitulatif.montantAcomptesAffectes">
          <td></td>
          <td>{{ $t('detail.commande.recapitulatifMontants.acompte') }}</td>
          <td class="right">{{ recapitulatif.montantAcomptesAffectes * -1 | formatDevise }}</td>
        </tr>
        <tr v-if="recapitulatif.montantAcomptesAffectes">
          <td></td>
          <td><strong>{{ $t('detail.commande.recapitulatifMontants.netAPayer') }}</strong></td>
          <td class="right"><strong>{{ montantNetAPayer | formatDevise }}</strong></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import decimalsFormaterService from '@/services/general/decimalsFormater';
import { formatDevise } from '@/services/general/filters/formatDevise';

export default {
  props: {
    recapitulatif: {
      type: Object,
      required: true,
    },
  },
  filters: {
    decimalFormatters(value) {
      return formatDevise(Number(decimalsFormaterService(value)));
    },
  },
  computed: {
    getTitleHors() {
      return this.recapitulatif.total.map((total => total.libelle)).join(', ');
    },
    montantNetAPayer() {
      return this.recapitulatif.montantTtc
        - this.recapitulatif.montantAcomptesAffectes;
    },
  },
};
</script>
